import React from 'react';
import Aux from '../../../hoc/Aux/Aux';
import Logo from '../../../components/Brand/Logo/Logo';
import {
    CloseBtn,
    Backdrop
} from '../../UI';
import SideMenuItems from '../SideMenuItems/SideMenuItems';
import AddLocalStrings from '../../../constants/AddLocalStrings';
import styles from './SideMenu.module.scss';

const SideMenu = (props) => {
    const { appData, localCode, showAdminSideMenu, closed, articleClickedHandler, articleName, userLevel } = props;
    let attachStyles = [ styles.SideMenu, styles.Close];
    
    if(showAdminSideMenu){
        attachStyles = [ styles.SideMenu, styles.Open ];
    }

    return(
        <Aux>
            <Backdrop 
                show={showAdminSideMenu}
                clicked={closed}
            />
            <div className={attachStyles.join(' ')}>
                <div style={{display:'flex', justifyContent:"space-between", alignItems:"center", marginBottom:'8px'}}>
                    <div style={{display:'flex', justifyContent:"center", alignItems:"center"}}>
                        <Logo width={20} localCode={localCode} />
                        <span className={styles.MenuTitle}>{AddLocalStrings[localCode].TAGUJAM_ADMIN}</span>
                    </div> 
                    <div style={{marginLeft:'8px', marginRight:'8px',}}> 
                    <CloseBtn clicked={closed} fontSize={20} color="gray"/>
                    </div>
                </div>
                <SideMenuItems 
                    articleClickedHandler={articleClickedHandler}
                    articleName={articleName}
                    userLevel={userLevel}
                    localCode={localCode}
                    appData={appData}
                />
            </div>
        </Aux>
    );
}

export default SideMenu;